import React from 'react';
import { Modal, Row} from "antd";
import 'antd/lib/modal/style/css';
import {Button} from "antd";

class MessageModal extends React.Component {

    render() {
        return (
            <Modal centered visible={this.props.modalType !== null} {...this.props.modalProps}>
                <Row className={'text-center block'}>
                    <strong>{this.props.message} </strong>
                </Row>
                <br />
                <br />
                <Row className={'text-center block'}>
                    <Button onClick={this.props.onOK} type={'primary'}>{this.props.btnOK}</Button>
                    <Button onClick={this.props.onCancel} type={'primary'}>{this.props.btnCancel}</Button>
                </Row>
            </Modal>
        )
    }

};

export default MessageModal;
